import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  step: 1,
  id: null,
  share_token: null,
  owner: {
    id: null,
  },
  vessel: {
    id: null,
  },
  share_contact: null,
  share_contact_email: null,
  emergency_contact: null,
  time_type: 'return',
  start_time: null,
  end_time: null,
  people_aboard: 0,
  loloEnabled: false,
  start_waypoint: {
    lat: 0,
    lon: 0,
  },
  end_waypoint: {
    lat: 0,
    lon: 0,
  },
  trip: {
    id: null,
    startTimestamp: null,
    endTimestamp: null,
  },
  created_at: null,
};

const floatPlanSlice = createSlice({
  name: 'float-plan',
  initialState,
  reducers: {
    setFloatPlan: (draft, action) => action.payload,
    setId: (draft, action) => {
      draft.id = action.payload;
      return draft;
    },
    setShareToken: (draft, action) => {
      draft.share_token = action.payload;
      return draft;
    },
    setStep: (draft, action) => {
      draft.step = action.payload;
      return draft;
    },
    setOwner: (draft, action) => {
      draft.owner = action.payload;
      return draft;
    },
    setVessel: (draft, action) => {
      draft.vessel = action.payload;
      return draft;
    },
    setShareContact: (draft, action) => {
      draft.share_contact = action.payload;
      return draft;
    },
    setShareContactEmail: (draft, action) => {
      draft.share_contact_email = action.payload;
      return draft;
    },
    setTimeType: (draft, action) => {
      draft.time_type = action.payload;
      return draft;
    },
    setStartTime: (draft, action) => {
      draft.start_time = action.payload;
      return draft;
    },
    setEndTime: (draft, action) => {
      draft.end_time = action.payload;
      return draft;
    },
    setPeopleOnBoard: (draft, action) => {
      draft.people_aboard = action.payload;
      return draft;
    },
    setEndWaypoint: (draft, action) => {
      draft.end_waypoint = action.payload;
      return draft;
    },
    setStartWaypoint: (draft, action) => {
      draft.start_waypoint = action.payload;
      return draft;
    },
    setLoloEnabled: (draft, action) => {
      draft.loloEnabled = action.payload;
      return draft;
    },
    reset: () => initialState,
  },
});

export const {
  setFloatPlan,
  setId,
  setShareToken,
  setStep,
  setOwner,
  setVessel,
  setShareContact,
  setShareContactEmail,
  setTimeType,
  setStartTime,
  setEndTime,
  setPeopleOnBoard,
  setEndWaypoint,
  setStartWaypoint,
  setLoloEnabled,
  reset,
} = floatPlanSlice.actions;

export default floatPlanSlice.reducer;
